module.exports = __webpack_public_path__ + "img/Feature.d00a6c75.png";